export const StatusPublishFeed = {
  PUBLISHING: 'PUBLISHING',
  PUBLISHED: 'PUBLISHED',
};
